export default __webpack_public_path__ + "static/media/search-icon.0f8ef5b0.svg";